/* ============================================================
   Mixer-Splash: Fortschritt über echte Lade-Meilensteine statt Zufallskurve.

   Läuft VOR dem Mixer-Bundle (is-land injiziert es erst bei Sichtbarkeit aus
   seinem <template>), funktioniert ohne die App und baut sich selbst ab, sobald
   .mixer-splash--fade-out gesetzt oder der Splash entfernt wird. Markup, CSS und
   Config (#mixer-splash-config) rendert sections/mixer.liquid; die App setzt
   weiterhin nur die Fade-out-Klasse.

   Failsafe: Lädt das Bundle nie (CDN-Fehler, Blocker), blendet sich der Splash
   nach FAILSAFE_MS selbst aus, statt die Seite dauerhaft zu verdecken.

   A11y: Die rotierenden Sätze sind rein visuell; angesagt werden nur der erste
   Satz und die Fertig-Meldung über die separate .mixer-splash__sr-status
   Live-Region — sonst würde ein Screenreader alle 2,2 s unterbrochen.
   ============================================================ */
(function () {
  'use strict';
  if (window.__mmMixerSplash) return;
  window.__mmMixerSplash = true;

  var splash = document.getElementById('mixer-splash');
  if (!splash) return;

  var FAILSAFE_MS = 20000;

  var cfg = { messages: [], slowMessages: [], doneMessage: '', interval: 2200, showBar: false, showPercent: false };
  try {
    var cfgEl = document.getElementById('mixer-splash-config');
    if (cfgEl) cfg = Object.assign(cfg, JSON.parse(cfgEl.textContent));
  } catch (e) { /* defekte Config → Splash bleibt einfach der heutige */ }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var barEl  = splash.querySelector('.mixer-splash__bar');
  var fillEl = splash.querySelector('.mixer-splash__bar-fill');
  var pctEl  = splash.querySelector('.mixer-splash__percent');
  var copyEl = splash.querySelector('.mixer-splash__copy');
  var srEl   = splash.querySelector('.mixer-splash__sr-status');
  var lines  = copyEl ? copyEl.querySelectorAll('.mixer-splash__copy-line') : [];

  var timers = [];
  var observers = [];
  var finished = false;

  function cleanup() {
    timers.forEach(function (t) { clearInterval(t); clearTimeout(t); });
    timers = [];
    observers.forEach(function (o) { o.disconnect(); });
    observers = [];
  }

  /* Ansage nur für Statuswechsel (erster Satz, Fertig-Meldung) — nie pro Rotation */
  function announce(msg) {
    if (srEl && msg) srEl.textContent = msg;
  }

  /* ── Sätze: Settings sind die einzige Quelle, NBSP vor „…" ─────────── */
  var nbspEllipsis = function (s) { return s.replace(/ …/g, ' …'); };
  var mainList = (cfg.messages || []).map(nbspEllipsis);
  var slowList = (cfg.slowMessages || []).map(nbspEllipsis);
  var activeList = mainList;
  var lastMsg = '';
  var activeLine = 0;

  function pickMessage(list) {
    if (!list.length) return '';
    if (list.length === 1) return list[0];
    var candidates = list.filter(function (m) { return m !== lastMsg; });
    return candidates[Math.floor(Math.random() * candidates.length)];
  }

  function showMessage(msg) {
    if (!copyEl || !lines.length || !msg) return;
    if (msg === lastMsg) return;
    lastMsg = msg;
    var next = (activeLine + 1) % lines.length;
    lines[next].textContent = msg;
    lines[activeLine].classList.remove('is-active');
    lines[next].classList.add('is-active');
    activeLine = next;
  }

  if (copyEl && mainList.length) {
    var firstMsg = pickMessage(mainList);
    showMessage(firstMsg);
    announce(firstMsg);
    if (!reduceMotion) {
      timers.push(setInterval(function () {
        showMessage(pickMessage(activeList));
      }, cfg.interval));
      /* Geduld-Fall: nach 8 s auf die kurze Liste wechseln und dort bleiben */
      if (slowList.length) {
        timers.push(setTimeout(function () { activeList = slowList; }, 8000));
      }
    }
  }

  /* ── Fortschritt: Meilensteine 15/30/55/80, 100 nur über Fade-out ──── */
  var needProgress = !!(barEl || pctEl);
  var MILESTONES = [15, 30, 55, 80];
  var reachedIdx = -1;
  var value = 0;
  var target = MILESTONES[0];
  var lastRendered = -1;
  var rafId = null;

  function render() {
    if (rafId) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      /* floor: 100 erscheint ausschließlich über den Fade-out-Meilenstein */
      var p = Math.floor(value);
      if (p === lastRendered) return;
      lastRendered = p;
      if (fillEl) fillEl.style.width = p + '%';
      if (barEl) barEl.setAttribute('aria-valuenow', String(p));
      if (pctEl) pctEl.textContent = p + ' %';
    });
  }

  function milestone(idx) {
    if (finished || idx <= reachedIdx) return;
    reachedIdx = idx;
    value = Math.max(value, MILESTONES[idx]);
    target = idx + 1 < MILESTONES.length ? MILESTONES[idx + 1] : 100;
    render();
  }

  function finish() {
    if (finished) return;
    finished = true;
    cleanup();
    value = 100;
    render();
    if (cfg.doneMessage) {
      lastMsg = '';
      var done = nbspEllipsis(cfg.doneMessage);
      showMessage(done);
      announce(done);
    }
  }

  if (needProgress) {
    /* Start = 15 % */
    milestone(0);

    /* 30 %: readyState interactive (bei defer-Load praktisch immer schon vorbei) */
    if (document.readyState !== 'loading') {
      milestone(1);
    } else {
      document.addEventListener('readystatechange', function onRs() {
        if (document.readyState !== 'loading') {
          document.removeEventListener('readystatechange', onRs);
          milestone(1);
        }
      });
    }

    /* 55 %: Mixer-Bundle geladen. is-land injiziert das <script> erst bei
       Sichtbarkeit aus dem <template> → auf das Auftauchen lauschen UND
       customElements.whenDefined als Cache-/Race-Fallback (Bundle definiert
       das Custom Element <mymuesli-mixer>). */
    function hookBundleScript(node) {
      if (!node || node.tagName !== 'SCRIPT') return false;
      var src = node.getAttribute('src') || '';
      if (src.indexOf('mymuesli-mixer-') === -1) return false;
      node.addEventListener('load', function () { milestone(2); });
      return true;
    }
    var existing = document.querySelector('script[src*="mymuesli-mixer-"]');
    if (!hookBundleScript(existing)) {
      var scriptObs = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            if (hookBundleScript(added[j])) { scriptObs.disconnect(); return; }
          }
        }
      });
      scriptObs.observe(document.documentElement, { childList: true, subtree: true });
      observers.push(scriptObs);
    }
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('mymuesli-mixer').then(function () { milestone(2); }).catch(function () {});
    }

    /* 80 %: App gemountet — erste Mutation im <mymuesli-mixer>-Element.
       Bei defer-Load existiert das Element in der Regel schon; der
       DOMContentLoaded-Retry bleibt als Race-Absicherung. */
    function hookMount() {
      var mount = document.querySelector('mymuesli-mixer');
      if (!mount) return false;
      var alreadyMounted = false;
      for (var c = 0; c < mount.children.length; c++) {
        if (mount.children[c].id !== 'muesli-mixer-json') { alreadyMounted = true; break; }
      }
      if (alreadyMounted) {
        milestone(3);
      } else {
        var mountObs = new MutationObserver(function () {
          milestone(3);
          mountObs.disconnect();
        });
        mountObs.observe(mount, { childList: true, subtree: true });
        observers.push(mountObs);
      }
      return true;
    }
    if (!hookMount()) {
      document.addEventListener('DOMContentLoaded', function () { hookMount(); });
    }

    /* Weiches Hochkriechen Richtung nächstem Meilenstein, nie darüber hinaus.
       Bei prefers-reduced-motion springt die Zahl nur auf Meilensteinwerte. */
    if (!reduceMotion) {
      timers.push(setInterval(function () {
        value = Math.max(value, value + (target - value) * 0.08);
        render();
      }, 150));
    }
  }

  /* ── Failsafe: Bundle kommt nie an → Splash darf die Seite nicht ewig
     verdecken. Kein doneMessage/100 % — es ist ja nichts fertig geworden. ── */
  timers.push(setTimeout(function () {
    if (finished) return;
    finished = true;
    cleanup();
    splash.classList.add('mixer-splash--fade-out');
    setTimeout(function () {
      if (splash.parentNode) splash.remove();
    }, 600);
  }, FAILSAFE_MS));

  /* ── 100 % / Selbstabbau: Fade-out-Klasse oder Splash aus dem DOM ──── */
  if (splash.classList.contains('mixer-splash--fade-out')) {
    finish();
    return;
  }
  var classObs = new MutationObserver(function () {
    if (splash.classList.contains('mixer-splash--fade-out')) finish();
  });
  classObs.observe(splash, { attributes: true, attributeFilter: ['class'] });
  observers.push(classObs);
  if (splash.parentNode) {
    var removeObs = new MutationObserver(function () {
      if (!document.documentElement.contains(splash)) { cleanup(); finished = true; }
    });
    removeObs.observe(splash.parentNode, { childList: true });
    observers.push(removeObs);
  }
})();
